<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">위치안내</h2>
            </div>

            <div class="page-section-wrap">
                <section class="page-section pb-0">
                    <div>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3161.194505723795!2d126.96008095117394!3d37.59758107969291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2ad006e6f8f%3A0x2d94339bb0d25ba3!2z7ISc7Jq47Yq567OE7IucIOyiheuhnOq1rCDsnpDtlZjrrLjroZw0Meq4uCA0!5e0!3m2!1sko!2skr!4v1651548005187!5m2!1sko!2skr" width="100%" height="500" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div class="pt-24 pb-34 pt-md-34 pb-md-44">
                        <v-row>
                            <v-col cols="12" lg="7">
                                <div class="page-text">
                                    <p class="font-size-16 font-weight-bold primary--text">ADDRESS</p>
                                    <p class="font-size-18 font-size-md-22">서울특별시 종로구 자하문로41길 4 (서울특별시 종로구 부암동 185-6)</p>
                                </div>
                            </v-col>
                            <v-col cols="12" lg="2">
                                <div class="page-text">
                                    <p class="font-size-16 font-weight-bold primary--text">TEL</p>
                                    <p class="font-size-18 font-size-md-22">02) 395-6987</p>
                                </div>
                            </v-col>
                            <v-col cols="12" lg="3">
                                <div class="page-text">
                                    <p class="font-size-16 font-weight-bold primary--text">MAIL</p>
                                    <p class="font-size-18 font-size-md-22">contact@kataauction.com</p>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="primary border-2"></v-divider>

                <section class="page-section">
                    <div class="mb-10">
                        <h4 class="tit tit--xs">오시는 길</h4>
                    </div>
                    <div>
                        <div class="table-scroll">
                            <div class="table-scroll__inner">
                                <v-simple-table class="v-simple-table v-data-table--none-active-bg v-data-table--default v-data-table--none-border-left" style="min-width:768px;">
                                    <tbody>
                                        <tr>
                                            <th style="width:11%;" class="text-center">버스</th>
                                            <td>
                                                <div class="page-text pa-16 px-md-30 py-md-20">
                                                    <p>하림각 정류장</p>
                                                    <p>1020, 1711, 7016, 7018, 7022, 7212, 8002번 </p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-center">지하철</th>
                                            <td>
                                                <div class="page-text pa-16 px-md-30 py-md-20">
                                                    <p>3호선 경복궁역 3번 출구  →  버스 1020, 1711, 7016, 7018, 7022, 7212, 8002번 환승  →  하림각 정류장 하차</p>
                                                    <p>5호선 광화문역 2번 출구  →  버스 1020, 1711, 7016, 7018, 7212번 환승  →  하림각 정류장 하차</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="text-center">자동차</th>
                                            <td>
                                                <div class="page-text pa-16 px-md-30 py-md-20">
                                                    <p>경복궁역에서 경복고등학교 방향으로 직진  →  자하문 터널  →  HW컨벤션센터(하림각) 앞 사거리에서 좌회전 →  30m 전방 우측 캐터옥션</p>
                                                    <p>＊ 내부순환로(성산) 방면 →  국민대입구에서 북악터널 방면으로 도시고속도로 출구→세검정에서 광화문 방면으로 좌회전  →  하림각 앞 사거리에서 우회전 →  30m 전방 우측 캐터옥션</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
export default {
    components: {
        ClientPage,
    },
};
</script>

<style lang="scss" scoped>
</style>